import { footerHTML } from '../ui/Footer';
import { navHTML } from '../ui/Nav';

export function renderAbout(container: HTMLElement) {
  container.innerHTML = `
    ${navHTML()}
    <main class="legal-content">
      <a href="#/" class="back-badge">&larr; Home</a>
      <h1>About StonkRider</h1>
      <p>StonkRider is a free browser game that turns real stock market charts into motocross tracks. Pick any stock ticker &mdash; Tesla, Bitcoin, Enron, GameStop &mdash; and ride its price history on a dirt bike. Every peak is a jump, every crash is a cliff.</p>

      <h2>How it works</h2>
      <p>Real market data is transformed into playable terrain. Flat stocks make smooth tracks, volatile stocks create wild jumps, and crashed stocks are deadly cliffs. The physics engine gives the bike realistic weight, suspension, and momentum.</p>

      <h2>Tricks &amp; scoring</h2>
      <p>Pull off tricks in the air &mdash; backflips, supermans, no-handers, dead sailors &mdash; or on the ground with wheelies, stoppies, and speed demons. Chain tricks without crashing to build your streak multiplier (up to &times;5). Named combos like Astronaut, Showoff, and Madman give bonus points.</p>

      <h2>Compete</h2>
      <ul>
        <li><strong>Daily challenge</strong> &mdash; every day at midnight UTC, a new stock chart is selected. All players ride the same track. <a href="#/leaderboard">See the leaderboard</a>.</li>
        <li><strong>Per-track leaderboards</strong> &mdash; best score and fastest time on 44+ stock charts.</li>
        <li><strong>Challenge friends</strong> &mdash; share your score and dare them to beat it.</li>
      </ul>

      <h2>Controls</h2>
      <ul>
        <li><strong>Desktop:</strong> Arrow keys &mdash; Up for gas, Left/Right to tilt the bike</li>
        <li><strong>Mobile:</strong> Tap left/right sides of the screen to tilt, tap both for gas</li>
      </ul>

      <h2>Available tracks</h2>
      <p><strong>Trending:</strong> Tesla, GameStop, Bitcoin, NVIDIA, Apple, S&amp;P 500, AMC, Meta, Amazon</p>
      <p><strong>Legendary crashes:</strong> Enron, Lehman Brothers, WorldCom, Credit Suisse, Wirecard, WeWork, and 23 more defunct companies</p>
      <p><strong>Hall of fame:</strong> BlackBerry, Cisco, GE, AIG, Citigroup, Nokia &mdash; stocks that crashed hard but survived</p>
      <p><strong>Live IPO:</strong> Ride IPO charts as they update in real time</p>
      <p>You can also search for any stock ticker on the <a href="#/">home page</a>.</p>

      <h2>Frequently asked questions</h2>
      <div class="faq">
        <details>
          <summary>What is StonkRider?</summary>
          <p>StonkRider is a free browser game that turns real stock market charts into motocross tracks. Every stock ticker generates unique terrain from its actual price history — you ride it on a dirt bike, pull tricks, and compete on leaderboards.</p>
        </details>
        <details>
          <summary>Is StonkRider free?</summary>
          <p>Yes — 100% free, no download, no signup, no account. Open stonkrider.com and pick a chart.</p>
        </details>
        <details>
          <summary>What are the controls?</summary>
          <p>Desktop: Up arrow for gas, Left/Right arrows to tilt the bike. Mobile: tap the left or right side of the screen to tilt, tap both sides for gas.</p>
        </details>
        <details>
          <summary>Does it work on mobile?</summary>
          <p>Yes. StonkRider runs in any modern mobile browser — rotate your phone to landscape to play. No app install needed.</p>
        </details>
        <details>
          <summary>Where does the data come from?</summary>
          <p>Stock prices come from Yahoo Finance, historical data for defunct companies from public market-cap archives, and startup revenue from TrustMRR, where founders publish their own figures. It's real data — never simulated.</p>
        </details>
        <details>
          <summary>How do leaderboards work?</summary>
          <p>Every day at midnight UTC a new chart becomes the daily challenge — same track for everyone. Each stock chart also has its own permanent top 3 for best score and fastest time.</p>
        </details>
      </div>

      <h2>Who made this</h2>
      <p>StonkRider was created by <a href="https://x.com/ooopsideployed" target="_blank" rel="noopener">Aymeric Dietrich</a>.</p>
    </main>
    ${footerHTML()}
  `;
}
